import { UtilsService } from '../services/utils.service';

export class Cache {
  public _data: any[];

  constructor(data?: any[]) {
    this.data = data;
  }

  set data(data: any[]) {
    this._data = data || [];
  }

  get data() {
    return this._data;
  }

  getById(id: string) {
    return id ? this.data.find((element) => element.id === id) : null;
  }

  fetch(options?: any): Promise<any> {
    return Promise.resolve({
      docs: this.sort(options.sort),
      page: 1,
      pages: 1,
      total: this.data.length
    });
  }

  sort(sortField) {
    if (sortField) {
      if (sortField.indexOf(',') !== -1) {
        sortField
          .split(',')
          .reverse()
          .forEach((field) => this.sort(field));
      } else {
        const field = sortField.startsWith('-') ? sortField.substring(1) : sortField;
        const order = sortField.startsWith('-') ? -1 : 1;
        this.data.sort((a, b) => {
          const valA = UtilsService.getDeepValue(a, field);
          const valB = UtilsService.getDeepValue(b, field);
          if (!valA || valA < valB) {
            return order * -1;
          }
          if (!valB || valA > valB) {
            return order * 1;
          }
          return 0;
        });
      }
    }
    return this.data;
  }
}
